import { DownloadReportsRepository } from "@adapters/repositories/Reports/common/downloadrepo";
import { http, accountDetails } from "@di";
import { EdelFileSaver } from "../../../di/FIleSaver";
export const downloadReportsRepo = new DownloadReportsRepository(http, new EdelFileSaver(), accountDetails);
